import styled from 'styled-components'

import { PaginationItem } from '@mui/material'
import _Pagination from '@mui/material/Pagination'

import theme from '~/shared/styles/theme'

function Pagination({ ...rest }) {
  return (
    <Wrapper {...rest} renderItem={(item) => <PaginationItem {...item} />} />
  )
}

export default Pagination

const Wrapper = styled(_Pagination)`
  display: flex;
  justify-content: center;

  button {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 20px;
    color: #6b7280;
  }

  .Mui-selected {
    color: ${theme.colors.mint_3};
    background-color: transparent;
    border: none;
    border-radius: 10px;
  }
`
